export const VALIDATE_FORM = 'VALIDATE_FORM';
export const VALIDATE_FIELD = 'VALIDATE_FIELD';
export const SET_VALIDATION_CONFIG = 'SET_VALIDATION_CONFIG';
export const RESET_VALIDATION_FIELDS = 'RESET_VALIDATION_FIELDS';
export const SET_FIELD_ERRORS = 'SET_FIELD_ERRORS';
